module.exports = __webpack_public_path__ + "img/paySixPicPc.a79d381a.png";